<div class="container" [ngSwitch]="mode">
    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>S/N</th>
          <th>Name</th>
          <th>
            <button class="add" mat-raised-button color="basic" (click)="addNew()">
              Add New
            </button>
          </th>
        </tr>
        <tr class="td" *ngFor="let title of titles">
          <td>{{title.Company_code}}</td>
          <td>{{title.Name}}</td>
          <td>
            <button mat-raised-button color="primary" (click)="edit(title)">
              Edit
            </button>
            <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(title)">
              Delete
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>

    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create Company</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Company Name</mat-label>
                <input formControlName="Name" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Address 1</mat-label>
                <input formControlName="Address1" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Address 2</mat-label>
                <input formControlName="Address2" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Mobile No</mat-label>
                <input formControlName="Tel_No" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input formControlName="Email_Addr" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Billing Address</mat-label>
                <input formControlName="billing_addr" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person <Address></Address></mat-label>
                <input formControlName="Contact_Person" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person Designation <Address></Address></mat-label>
                <input formControlName="Contact_person_Designation" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person Mobile <Address></Address></mat-label>
                <input formControlName="Contact_Person_Mobile_No" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Package Breakup</mat-label>
                <mat-select formControlName="package_breakup" matNativeControl required>
                  <mat-option value="N">No</mat-option>
                  <mat-option value="Y">Yes</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Payment Type</mat-label>
                <mat-select formControlName="Payment_Type" matNativeControl required>
                  <mat-option value="C">Cash</mat-option>
                  <mat-option value="B">Bank Transfer</mat-option>
                  <mat-option value="Q">Cheque</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="status" matNativeControl required>
                  <mat-option value="Active">Active</mat-option>
                  <mat-option value="Inactive">Inactive</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Discount <Address></Address></mat-label>
                <input formControlName="discount" matInput type="number" placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Remarks<Address></Address></mat-label>
                <input formControlName="Remarks" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Standard Price Valid ID <Address></Address></mat-label>
                <input formControlName="Standard_Price_Valid_Id" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Special Price Valid ID <Address></Address></mat-label>
                <input formControlName="Special_Price_Valid_Id" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div> 
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit Company</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Company Name</mat-label>
                <input formControlName="Name" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Address 1</mat-label>
                <input formControlName="Address1" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Address 2</mat-label>
                <input formControlName="Address2" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Mobile No</mat-label>
                <input formControlName="Tel_No" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input formControlName="Email_Addr" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Billing Address</mat-label>
                <input formControlName="billing_addr" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person <Address></Address></mat-label>
                <input formControlName="Contact_Person" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person Designation <Address></Address></mat-label>
                <input formControlName="Contact_person_Designation" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Contact Person Mobile <Address></Address></mat-label>
                <input formControlName="Contact_Person_Mobile_No" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Package Breakup</mat-label>
                <mat-select formControlName="package_breakup" matNativeControl required>
                  <mat-option value="N">No</mat-option>
                  <mat-option value="Y">Yes</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Payment Type</mat-label>
                <mat-select formControlName="Payment_Type" matNativeControl required>
                  <mat-option value="C">Cash</mat-option>
                  <mat-option value="B">Bank Transfer</mat-option>
                  <mat-option value="Q">Cheque</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="status" matNativeControl required>
                  <mat-option value="Active">Active</mat-option>
                  <mat-option value="Inactive">Inactive</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Discount <Address></Address></mat-label>
                <input formControlName="discount" matInput type="number" placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Remarks<Address></Address></mat-label>
                <input formControlName="Remarks" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Standard Price Valid ID <Address></Address></mat-label>
                <input formControlName="Standard_Price_Valid_Id" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Special Price Valid ID <Address></Address></mat-label>
                <input formControlName="Special_Price_Valid_Id" type="number" matInput placeholder="">
              </mat-form-field>
          </span>
          
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div> 
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    
    
  </div>